export enum TAB_KEY {
    DAY_TRIPS = 'day-trips',
    WEEKEND_TRIPS = 'weekend-trips',
}

export interface ImageConfig {
    pc: string;
    h5: string;
}

export interface ConsultCardConfig {
    label: string;
    title: string;
    desc: string;
    btn: string;
    img: ImageConfig;
    href: string;
}

export interface ProductConfig {
    productId: string;
    variantId: string;
    label?: string;
    /** 卖点列表，可多条 */
    desc: string[];
    skuTitle?: string;
    handle?: string;
    worksWith?: string;
}

export interface TabDataConfig {
    tabLabel: string;
    label: string;
    title: string;
    desc: string;
    image: ImageConfig;
    products: ProductConfig[];
    consultCard?: ConsultCardConfig;
}

type TranslateFn = (key: string) => string;

const getAuTabsConfig = (_t: TranslateFn): Record<TAB_KEY, TabDataConfig> => ({
    [TAB_KEY.DAY_TRIPS]: {
        tabLabel: 'Day Trips',
        label: '',
        title: 'Day Trips',
        desc: '',
        image: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231915836-y1lg37-compressed-Frame%201612708366.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232435129-v4qy1t-compressed-Frame%202094655112.webp',
        },
        products: [
            {
                productId: '7756526026950',
                variantId: '42649690210502',
                handle: 'river-2-max-portable-power-station',
                label: '512Wh (40Ah) | 500W | X-Boost to 1000W',
                skuTitle: 'EcoFlow RIVER 2 Max',
                desc: ['Charge 0-100% in 60 min', 'Lightweight at only 6.1 kg', 'Power up to 1.5kWh a day with solar charging'],
            },
            {
                productId: '7756526584006',
                variantId: '42673598824646',
                handle: 'river-2-pro-portable-power-station',
                label: '768Wh (64Ah) | 800W | 1600W X-Boost',
                skuTitle: 'EcoFlow RIVER 2 Pro',
                desc: ['Charge 0-100% in 70 min', 'LFP battery offers 10 years of use', 'Capture up to 1.8kWh/day with a solar panel'],
            },
        ],
    },
    [TAB_KEY.WEEKEND_TRIPS]: {
        tabLabel: 'Weekend Trips',
        label: '',
        title: 'Weekend Trips',
        desc: '',
        image: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231924078-7y78s1-compressed-Frame%202094655104.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232449199-gr5qvg-compressed-Frame%202094655110.webp',
        },
        products: [
            {
                productId: '8435739197638',
                variantId: '44378294452422',
                handle: 'ecoflow-delta-3-plus-portable-power-station',
                label: '1024Wh (85Ah@12V) | 1800W | 1000W Solar Input',
                skuTitle: 'EcoFlow DELTA 3 Plus',
                desc: ['Plug-and-play design', 'Charges to 80% in just 50 minutes'],
            },
            {
                productId: '7914502422726',
                variantId: '43045698371782',
                handle: 'delta-2-max-portable-power-station',
                label: '2048Wh (167Ah@12V) | 2400W | 3100W X-Boost',
                skuTitle: 'EcoFlow DELTA 2 Max',
                desc: [
                    'Built to last 6x longer',
                    'Charge from 0-80% in 43 min',
                    'Up to two DELTA 2 Max Smart Extra Batteries to hit 6144Wh',
                ],
            },
        ],
    },
});

export const getTabsConfig = (t: TranslateFn, _locale = 'au') => {
    const tabData = getAuTabsConfig(t);

    return Object.entries(tabData).map(([key, data]) => ({
        key: key as TAB_KEY,
        ...data,
    }));
};
